import * as yup from 'yup';

/**
 * Validation schema for Approval Requests module
 * Based on the field configurations in approvalRequestsConfig.js
 */
export const createApprovalRequestsValidationSchema = () => {
  return yup.object().shape({
    // Basic Information
    code: yup
      .string()
      .required('Approval code is required')
      .matches(/^[A-Z0-9-]+$/, 'Code must contain only uppercase letters, numbers, and hyphens')
      .max(50, 'Code must be at most 50 characters'),
    
    title: yup
      .string()
      .required('Approval title is required')
      .min(3, 'Title must be at least 3 characters')
      .max(255, 'Title must be at most 255 characters'),
    
    description: yup
      .string()
      .nullable()
      .max(1000, 'Description must be at most 1000 characters'),
    
    // Status and Priority
    status: yup
      .string()
      .required('Status is required')
      .oneOf(['pending', 'approved', 'rejected', 'cancelled'], 'Invalid status'),
    
    priority: yup
      .string()
      .required('Priority is required')
      .oneOf(['low', 'medium', 'high', 'urgent'], 'Invalid priority'),
    
    // Entity Information
    entityType: yup
      .string()
      .required('Entity type is required')
      .oneOf(['document', 'capa', 'change_request', 'training', 'supplier', 'custom'], 'Invalid entity type'),
    
    entityId: yup
      .number()
      .nullable()
      .positive('Entity ID must be a positive number')
      .integer('Entity ID must be an integer'),
    
    entityData: yup
      .mixed()
      .nullable()
      .test('is-valid-json', 'Entity data must be valid JSON', function(value) {
        if (!value) return true;
        if (typeof value === 'object') return true;
        try {
          JSON.parse(value);
          return true;
        } catch (e) {
          return false;
        }
      }),
    
    // Approval Configuration
    approvalType: yup
      .string()
      .required('Approval type is required')
      .oneOf(['single', 'sequential', 'parallel', 'any_one'], 'Invalid approval type'),
    
    currentStep: yup
      .number()
      .nullable()
      .min(1, 'Current step must be at least 1')
      .integer('Current step must be an integer'),
    
    totalSteps: yup
      .number()
      .nullable()
      .min(1, 'Total steps must be at least 1')
      .integer('Total steps must be an integer'),
    
    // Dates
    dueDate: yup
      .date()
      .nullable()
      .min(new Date(), 'Due date must be in the future'),
    
    requestedAt: yup
      .date()
      .nullable(),
    
    approvedAt: yup
      .date()
      .nullable(),
    
    // Comments and Notes
    comments: yup
      .string()
      .nullable()
      .max(1000, 'Comments must be at most 1000 characters'),
    
    rejectionReason: yup
      .string()
      .nullable()
      .max(1000, 'Rejection reason must be at most 1000 characters'),
    
    // File Attachments
    fileAttachments: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string().required(),
          name: yup.string().required(),
          size: yup.number().required(),
          type: yup.string().required(),
          url: yup.string().required()
        })
      )
      .default([])
  });
};

export default createApprovalRequestsValidationSchema;
